<script>

export let addSection;
    
</script>
<div class="add-section-button shadow-sm" on:click="{addSection}">+ Add new section</div>

<style>
    .add-section-button {
        border: none;
        width: 200px;
        display:flex;
        align-items: center;
        cursor:pointer;
        border-radius: 7px;
        background: #242424;
        color: #ffffff;
        text-align: center;
        justify-content: center;
        margin: 20px auto;
        padding: 10px 20px;
    }
    .add-section-button:hover {
        box-shadow: 0px 0px 10px #242424;
    }
</style>